import { supabaseClient } from "@/lib/supabase";

import { createRedirectUrl } from "./createRedirectUrl";

export const sendPasswordRecoveryEmail = async (email: string) => {
    const url = createRedirectUrl("/change-password");
    const { error } = await supabaseClient.auth.resetPasswordForEmail(email, {
        redirectTo: url,
    });
    if (error) throw error;
};
